module.exports = __webpack_public_path__ + "static/media/the-phantom-menace.43c482e3.png";